<template>
    <div :style="{'background-color':background_color}">
        <div class="container">
            <div class="text-center m-4">
              <img width="150px" :src="logo_url" alt="logo">
            </div>
            <h2 class="text-white text-center m-4">{{app_name}}</h2>
            <h2 class="text-white text-center m-4">Política de Privacidade</h2>
            <div class="row m-2">
                <div class="div-policy" v-html="text"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        components: {

        },
        data: function () {
            return {
                text: null,
            }
        },
        mounted() {
            axios.get('/api/webdriver/landpage', {params: {tags: 'politica_de_privacidade'}}).then(res => {
                this.text = res.data.data[0].content;
            });

        },
        computed: {
            app_name: function () {
                return process.env.VUE_APP_NAME;
            },
            logo_url: function () {
                return require('@/assets/imgs/logos/' + process.env.VUE_APP_LOGO_NAME);
            },
            background_color: function () {
              return process.env.VUE_APP_COLOR;
            }
        },
        methods: {
            changeClass(value) {
                if(value === 'Estar Digital Curitiba'){
                    return 'bg-green-page';
                }else{
                    return 'bg-blue-page';
                }
            }
        }
    }
</script>
<style scoped>
    .div-policy {
        background: white;
        padding: 15px;
        border-radius: 15px;
    }


    .div-estar {
        background-color: white;
        margin: 0 auto;
        width: 100px;
        height: 100px;
        border-radius: 200px;
    }

    .logo-estar {
        height: 75px;
        margin: 13px auto;
        display: table;
    }

    .bg-blue-page {
        background-color: #003A73 !important;
    }

    .bg-green-page {
        background-color: #259e64 !important;
    }

    i {
        color: #ffffff;
        font-size: 100px;
    }

    h2 {
        font-size: 34px;
        color: #ffffff;
        font-family: Roboto-Black;
    }

    h5 {
        font-family: Roboto-Black;
        font-size: 24px;
        color: #58595B;
    }

    p {
        font-size: 14px;
        color: #ffffff;
        font-family: Roboto-Regular;
        margin: 0;
    }


    @media only screen and (max-width: 768px) {
        * {
            text-align: center !important;
        }

        p {
            margin-top: 20px;
            margin-bottom: 5px;
        }
    }
</style>
